/**
 * Get tire puncture protection display text based on flag value
 * @param flag - The puncture protection flag (0-4)
 * @returns Display text for puncture protection
 */
export const getTirePunctureDisplay = (flag: number): string => {
  const punctureMap: Record<number, string> = {
    0: "なし",
    1: "1本補償",
    2: "2本補償",
    3: "3本補償",
    4: "4本補償",
  };
  return punctureMap[flag] || "-";
};

export default getTirePunctureDisplay;
